import { useAppUserAccess } from 'global/cnr/contexts/useHelpers/useAppUserAccess'
import _ from 'lodash'
import { useContext, useEffect, useState } from 'react'
import { Label, List, Segment } from 'semantic-ui-react'
import { ParentContext } from '../../cnr/contexts/ParentContext'
import { convertHelpers } from '../../common/convert'
import { uniqueKey } from '../../common/keys'
import UiSaveButtons from '../../components/buttons/UiSaveButtons'
import { appFormTypes } from '../../enums/appFormTypes'
import { appIconTypes } from '../../enums/appIconTypes'
import { createRefPath_event } from '../../firestoreData/appData/appRefPaths'
import FullPageWrapper from '../../wrappers/FullPageWrapper'
import Wrapper, { wrapperTypes } from '../../wrappers/Wrapper'
import NoData from '../alerts/NoData'
import AppForm from '../forms/appForms/AppForm'
import { useNavigate } from 'react-router-dom'

const UserFamily = (props) => {

  const { fullPage } = props ?? {}

  const navigate = useNavigate();

  const parentContext = useContext(ParentContext);
  const { states, fns } = parentContext ?? {}
  const { paps_state } = states ?? {}
  const { database_fns } = fns ?? {}

  const appUserAccess = useAppUserAccess()
  const { appUserSession } = appUserAccess ?? {}
  const { _itemKey } = appUserSession ?? {}

  const { pathViews } = paps_state

  const [showAdd, setShowAdd] = useState()
  const [familyMembers, setFamilyMembers] = useState()
  const [currentFamilyItem, setCurrentFamilyItem] = useState()

  const { familyMembers: _familyMembers } = familyMembers ? familyMembers : {}

  useEffect(() => {
    if (_itemKey) {
      const cb = (res) => { setFamilyMembers(res) }
      const _refPath = createRefPath_event(pathViews, ['_family', _itemKey])
      database_fns.get_data({ refPath: _refPath, callback: cb, opts: { listen: true, returnFirstObject: true, ignoreId: true } })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, []);

  const handleCancelForm = () => {
    setShowAdd()
    setCurrentFamilyItem()
  }

  const handleShowAdd = () => setShowAdd(!showAdd)
  const handleShowFamilyItem = (familyMember) => setCurrentFamilyItem(familyMember)

  const handleUpdate = (fms) => {
    const cb = () => handleCancelForm()
    const _refPath = createRefPath_event(pathViews, ['_family', _itemKey])
    const dtu = { familyMembers: fms }
    database_fns.update_docc({
      refPath: _refPath,
      data: dtu,
      callback: cb
    })
  }

  const handleDelete = () => {
    const { firstName, lastName } = currentFamilyItem ? currentFamilyItem : {}
    const _fms = _familyMembers ? [..._familyMembers] : []
    const fmi = _.findIndex(_fms, function (f) {
      return (f.firstName === firstName || f.lastName === lastName);
    })
    _fms.splice(fmi, 1);
    handleUpdate(_fms)
  }

  const handleSave = (formData) => {
    const _fms = _familyMembers ? [..._familyMembers] : []
    _fms.push(formData)
    handleUpdate(_fms)
  }

  const handleCancel = () => props.handleCancel ? props.handleCancel() : navigate(-1)

  const form = () => <AppForm
    appFormType={appFormTypes.family}
    handleSave={handleSave}
    handleDelete={currentFamilyItem && handleDelete}
    handleCancel={handleCancelForm}
    data_parent={currentFamilyItem}
  />

  const familyList = () => {
    const listItems = []
    if (_familyMembers) {
      _familyMembers.forEach((familyMember, index) => {
        const { _itemKey } = familyMember
        const name = convertHelpers.getItemName(familyMember)
        listItems.push(<List.Item key={uniqueKey('aul', _itemKey)} onClick={(e) => { handleShowFamilyItem(familyMember) }}>
          <List.Content floated='left'>
            <Label color={'green'} size='tiny'>{index + 1}</Label>
          </List.Content>
          <List.Content>
            <List.Header>{name} </List.Header>
          </List.Content>
        </List.Item>)
      })
    }
    return listItems.length > 0 ? <Segment basic>
      <List divided relaxed>
        {listItems}
      </List>
    </Segment> :
      <NoData altCaption={'Family'} />
  }

  const footer_add = () => {
    const btns = [
      { caption: 'Add', oc: handleShowAdd, color: 'blue', icon: appIconTypes.add },
    ]
    return <UiSaveButtons others={btns} />
  }

  const wrapper_list = () => <Wrapper
    content={familyList()}
    footer={footer_add()}
    wrapperType={wrapperTypes.paddedFooter}
  />


  const fpw_add = () => <FullPageWrapper
    content={form()}
    handleCancel={handleCancelForm}
    topperCaption={'Family Member'}
  />

  const fpw_list = () => <FullPageWrapper
    content={wrapper_list()}
    handleCancel={handleCancel}
    topperCaption={'Family'}
  />

  if (fullPage) {
    if (showAdd || currentFamilyItem) {
      return fpw_add()
    } else {
      return fpw_list()
    }
  } else {
    if (showAdd || currentFamilyItem) {
      return fpw_add()
    } else {
      return wrapper_list()
    }
  }
}

export default UserFamily